var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pay-line"},[_c('img',{staticClass:"l-pic",attrs:{"src":require('@/assets/images/Mall/p1.png'),"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }